import { IPAGE } from '@/types/base.d';

import fetch from './index';

// ------------------ COURSER-HOMEWORK 课上作业
// 校验题md5是否存在
const checkQuestionMd5 = (data: Array<string>) => fetch.axios_admin.post('/question/choice/md5', data);

// 上传题图片
const uploadQuestionFiles = (data: FormData) => fetch.axios_admin.post('/question/choice/file', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});


// 为章节添加题库
const setChapterQuestions = (data: { cid: string, ids: Array<{ id: string, sort: number }> }) => fetch.axios_admin.post('/course/chapter/questions', data);

// 获取所有课程类型
const getCourseType = () => fetch.axios_admin.get('/course/type/cascader');

// 获取所有某一类型下的所有课程
const getCourseByType = (tid: string) => fetch.axios_admin.get(`/course/cascader/?tid=${tid}`);

// 获取所有练习题
const getQuestion = (params: IPAGE) => fetch.axios_admin.get('/question/choice', { params });

// 检查练习题是否存在关联
const checkQues = (qid: string) => fetch.axios_admin.get(`/question/choice/relevance?qid=${qid}`);

// 修改练习题
const editQuestion = (params: any) => fetch.axios_admin.post('/question/choice', params, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 获取本节课关联的练习题
const getAllocted = (params: {cid: string}) => fetch.axios_admin.get(`/course/chapter/questions/?cid=${params.cid}&r=1`);

// 给课程章节批量关联练习题
const alloctedQues = (params: any) => fetch.axios_admin.post('course/chapter/questions', params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });

// 删除题库练习题
const removeQues = (ids: Array<string>) => fetch.axios_admin.remove(`/question/choice/?ids=${ids}`);

// ------------------ COURSER-HOMEWORK 课后作业

// 获取课后作业
const getHomeWork = (params: IPAGE) => fetch.axios_admin.get('/homework/question', { params });

// 添加课后作业
const addHomeWork = (params: any) => fetch.axios_admin.post('/homework/question', params);

// 修改课后作业
const editHomeWork = (params: any) => fetch.axios_admin.put('/homework/question', params);

// 删除课后作业
const removeHomeWork = (id: string) => fetch.axios_admin.remove(`/homework/question/${id}`);

export default {
  getCourseType,
  getCourseByType,
  getQuestion,
  getAllocted,
  alloctedQues,
  removeQues,
  editQuestion,
  checkQuestionMd5,
  uploadQuestionFiles,
  setChapterQuestions,
  checkQues,
  getHomeWork,
  addHomeWork,
  editHomeWork,
  removeHomeWork,
};
